import { useToast } from "contexts/ToastContext";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingPageIcon } from "utils/constant";

import { useParams } from "react-router-dom";
import { getStakeholder } from "services/getEmployees";
import { useAuth } from "contexts/AuthContext";
import RegistrarLegislativeDraft from "./registrarLegislativeDraft";
import DirectorLegislativeDraftRequest from "./directorLegislativeDraftRequest";
import LegalAdvisoryDetail from "./fragments/leftPanel";
import LegalAdvisoryRightPanel from "./fragments/rightPanel";
import { getSectorDirective } from "services/sectorDirectives";

const SingleSectorDirectives = () => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const [data, setData] = useState({
        isLoading: true, status: "", forward_status: "",
    });
    const { id } = useParams<{ id: string }>();
    const contextData = useAuth();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getSectorDirective(id || "", contextData.token || contextData?.user?.access_token || "");
                let user = null;
                if (response.requested_by_id && response.requested_by !== "internal") {
                    try {
                        user = await getStakeholder(response.requested_by_id, contextData.token || contextData?.user?.access_token || "");
                    } catch (err) {
                        console.error("Error fetching stakeholder:", err);
                        showToast(t("FailedToFetchStakeholder"), "error");
                    }
                }
                setData({
                    isLoading: false,
                    ...response,
                    requested_by_user: user,
                });
            } catch (error) {
                console.error("Error fetching legal research request:", error);
                showToast(t("FailedToFetchLegalResearchRequest"), "error");
                setData((prev) => ({ ...prev, isLoading: false }));
            }
        };

        fetchData();
    }, [id]);

    if (data.isLoading) // No text here
        return (
            <div className="flex justify-center items-center h-64">
                {LoadingPageIcon}
            </div>
        );

    if (contextData?.user?.roles?.some((p) => p === "Registrar"))
        return <RegistrarLegislativeDraft request={data} />

    return (
        <div className="flex h-full bg-gray-100 p-2">
            <LegalAdvisoryDetail request={data} />
            <LegalAdvisoryRightPanel request={data} />
        </div>
    );
};

export default SingleSectorDirectives;
